module.exports = __webpack_public_path__ + "img/디지털기술.03e4e827.png";